import { Component, ErrorInfo, ReactNode } from 'react';
import { reportErrorToDatadog } from '../logging/datadog';

export class ErrorBoundary extends Component<{ children?: ReactNode }, any> {
    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        reportErrorToDatadog(error, { componentStack: errorInfo.componentStack });
    }

    render() {
        return this.props.children;
    }
}
